import React from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';


function CompRodape(props) {
  return (
    <Navbar bg="light" expand="lg" fixed="bottom">
      <Navbar.Brand>
        Rodapé
        <Link to="/cad">Cadastro</Link>
      </Navbar.Brand>
      <Nav className="mr-auto">
      </Nav>
    </Navbar>
  );
}

export default CompRodape;
